<template>
  <div class="breadcrumb-wrapper">
    <div class="progress-bar">
      <div class="line"></div>
      <div class="dots">
        <div class="dot" :class="{'active': isStep1, 'completed': isStep2}"></div>
        <div class="dot" :class="{'active': isStep2}"></div>
      </div>
    </div>
    <ul class="breadcrumb">
      <li class="breadcrumb-item" :class="{'active': isStep1, 'completed': isStep2}">Szczegóły doładowania</li>
      <li class="breadcrumb-item" :class="{'active': isStep2}">Podsumowanie i płatność</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TopupEnergyBreadcrumbs',
  computed: {
    ...mapState({
      calculationData: state => state.energy.calculationData,
      calculationStatus: state => state.energy.calculationStatus
    }),
    isStep1: function () {
      return this.calculationData === null
    },
    isStep2: function () {
      return this.calculationData !== null
    }
  }
}
</script>
